module.exports = function(it, Constructor, name){
  if(!(it instanceof Constructor))throw TypeError(name + ": use the 'new' operator!");
  return it;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/$.strict-new.js
// module id = 122
// module chunks = 2